<template>
  <div>
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px;">
          <h3 style="color:#42352E;">Carga de archivo</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="formValido" lazy-validation>
            <v-row>
              <v-col cols="12" md="8">
                <v-file-input
                  v-model="archivo"
                  label="Archivo CSV"
                  prepend-icon="mdi-paperclip"
                  outlined
                  dense
                  background-color="white"
                  accept=".csv,text/csv"
                  :rules="reglasArchivo"
                  :disabled="loading"
                />
              </v-col>

              <v-col cols="12" md="4" class="text-end">
                <v-btn
                  dark
                  color="#00a7e4"
                  rounded
                  min-width="120"
                  :loading="loading"
                  :disabled="!archivo || !esCSV || loading"
                  @click="enviarArchivo"
                >
                  Almacenar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { postCargarArchivoAlianzaBetter } from "@/services/emision/emision.service";

export default {
  data() {
    return {
      archivo: null,
      formValido: true,
      loading: false,
      reglasArchivo: [
        (archivo) => !!archivo || "Debe subir un archivo",
        (archivo) =>
          !archivo ||
          archivo.name.toLowerCase().endsWith(".csv") ||
          "El archivo debe ser CSV",
      ],
    };
  },
  computed: {
    esCSV() {
      return Boolean(
        this.archivo && this.archivo.name.toLowerCase().endsWith(".csv")
      );
    },
  },
  methods: {
    async enviarArchivo() {
      if (!this.$refs.form.validate() || !this.esCSV) return;

      this.loading = true;
      try {
        const job = await postCargarArchivoAlianzaBetter(this.archivo);
        this.$toast.success(
          `Archivo enviado correctamente. Proceso ${job.jobId} iniciado.`
        );
        this.archivo = null;
        this.$refs.form.resetValidation();
        this.$emit("archivoEnviado", job);
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al enviar el archivo.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}

.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}
</style>
